import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    header: {
      title: translate({ id: 'modal.collectRecurrenceTargetRange.header.title.bulk' }),
    },
    radio: {
      order: translate({ id: 'modal.collectRecurrenceTargetRange.radio.order.bulk' }),
      future: translate({ id: 'modal.collectRecurrenceTargetRange.radio.future.bulk' }),
      all: {
        text: translate({ id: 'modal.collectRecurrenceTargetRange.radio.all.bulk' }),
        alert: translate({ id: 'modal.collectRecurrenceTargetRange.radio.all.bulk.alert' }),
      },
    },

    footer: {
      save: translate({ id: 'modal.collectRecurrenceTargetRange.footer.save' }),
      cancel: translate({ id: 'modal.collectRecurrenceTargetRange.footer.cancel' }),
    },
  }))

  return api
}
